module.exports = __webpack_public_path__ + "img/Clear Lab_Down.590699d9.svg";